import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import "./Cards.css";
import { Container } from "react-bootstrap";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import eye from "../../../Asset/blog/eye.svg";
import logo from "../../../Asset/blog/logo-web.png";
import share from "../../../Asset/blog/share.svg";
import { useNavigate } from "react-router-dom";
import blogData from "../../../blog";

const categoryList = [
  "Shipping",
  "Fitness & Wellness",
  "Fintech",
  "Ecommerce",
  "Real estate",
  "Technology",
  "Travel",
  "Healthcare",
  "Logistic",
  "Miscellaneous",
  "Others",
];

const Cards = () => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 6;

  const toggleDropdown = (visible) => setIsDropdownVisible(visible);

  const repeatedblogData = Array(10).fill(blogData).flat();

  const offset = currentPage * itemsPerPage;
  const currentItems = repeatedblogData.slice(offset, offset + itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const navigate = useNavigate();
  const handleNavigate = (title) => {
    navigate("/Blog/Card1", { state: { title } });
  };

  return (
    <section className="cards-section-blog">
      <Container>
        <div className="mb-5 form_serch_wrap">
          <div className="blog_custom_search_inner">
            <input type="text" placeholder="Search..." />
            <button type="submit" className="magnify-btn">
              <FaMagnifyingGlass />
            </button>
          </div>
          <div className="d-flex justify-content-end">
            <div
              className="dropdown profile-tech"
              onMouseEnter={() => toggleDropdown(true)}
              onMouseLeave={() => toggleDropdown(false)}
            >
              <button className="btn btn-primary">
                CATEGORIES <IoIosArrowDown className="icon" />
              </button>
              <ul
                className={`nav-filter dropdown-content ${
                  isDropdownVisible ? "show" : ""
                }`}
              >
                {categoryList.map((category, index) => (
                  <li key={index}>
                    <p>{category}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="page-number">
            <h4>Page no : {currentPage + 1}</h4>
          </div>
          <div className="post-list mt-4">
            {currentItems.map((card) => (
              <div
                className="blog-post"
                key={card.id}
                onClick={() => handleNavigate(card.title)}
              >
                <span className="post-thumb-img">
                  <img src={card.image} alt={card.title} />
                </span>
                <div className="blog-post-inner">
                  <div className="post-cat">
                    <span className="post-meta-cat">{card.category}</span>
                    <div className="post-views">
                      <div className="img">
                        <img src={eye} alt="views" />
                      </div>
                      <div className="view_count">{card.views} views</div>
                    </div>
                  </div>
                  <div className="post-title">
                    <p>{card.title}</p>
                  </div>
                  <div className="post-meta-share-block">
                    <div className="post-meta">
                      <div className="post-avatar">
                        <img src={logo} alt="author" />
                      </div>
                      <div className="post-data">
                        <div className="post-user-name">{card.author}</div>
                        <span className="post-date">{card.date}</span>
                      </div>
                    </div>
                    <div className="post-share-block">
                      <img src={share} alt="share" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            pageCount={Math.ceil(repeatedblogData.length / itemsPerPage)}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
          />
        </div>
      </Container>
    </section>
  );
};

export default Cards;
